if (!customElements.get('localization-form')) {
  customElements.define(
    'localization-form',
    class LocalizationForm extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
          button: this.querySelector('button'),
          panel: this.querySelector('.disclosure__list-wrapper'),
        };

        this.handleButtonClick = this.handleButtonClick.bind(this);
        this.handleDocumentClick = this.handleDocumentClick.bind(this);
        this.onContainerKeyUp = this.onContainerKeyUp.bind(this);
        this.onItemClick = this.onItemClick.bind(this);

        this.elements.button.addEventListener('click', this.handleButtonClick);
        this.addEventListener('keyup', this.onContainerKeyUp);
        this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick));
      }

      showPanel() {
        this.elements.button.setAttribute('aria-expanded', 'true');
        this.elements.panel.removeAttribute('hidden');
        // Add document click listener when panel is open
        document.addEventListener('click', this.handleDocumentClick);
      }

      hidePanel() {
        this.elements.button.setAttribute('aria-expanded', 'false');
        this.elements.panel.setAttribute('hidden', true);
        document.removeEventListener('click', this.handleDocumentClick);
      }

      handleButtonClick(event) {
        event.preventDefault();
        event.stopPropagation();

        const isExpanded = this.elements.button.getAttribute('aria-expanded') === 'true';

        if (isExpanded) {
          this.hidePanel();
        } else {
          this.showPanel();
        }
      }

      handleDocumentClick(event) {
        if (!this.contains(event.target)) {
          this.hidePanel();
        }
      }

      onContainerKeyUp(event) {
        if (event.code.toUpperCase() !== 'ESCAPE') return;

        if (this.elements.button.getAttribute('aria-expanded') === 'false') return;
        this.hidePanel();
        event.stopPropagation();
        this.elements.button.focus();
      }

      onItemClick(event) {
        event.preventDefault();
        const form = this.querySelector('form');
        this.elements.input.value = event.currentTarget.dataset.value;
        if (form) form.submit();
      }

      disconnectedCallback() {
        document.removeEventListener('click', this.handleDocumentClick);
      }
    }
  );
}
